import React from 'react';
import { Facebook, Instagram, Linkedin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <>
      <footer className="site-footer">
        <div className="footer-container">
          <div className="footer-social">
            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="social-link">
              <Facebook size={20} />
              <span>Facebook</span>
            </a>
            <a href="https://www.instagram.com/aasps_pt/" target="_blank" rel="noopener noreferrer" className="social-link">
              <Instagram size={20} />
              <span>Instagram</span>
            </a>
            <a href="#" className="social-link">
              <Linkedin size={20} />
              <span>Linkedin</span>
            </a>
          </div>
          
          <div className="footer-links">
            <a href="/politica-privacidade" className="footer-link">Política de Privacidade</a>
            <a href="/politica-cookies" className="footer-link">Política de Cookies</a>
            <a href="/contactos" className="footer-link">Contactos</a>
            <a href="/elogios-reclamacoes" className="footer-link">Elogios, Sugestões e Reclamações</a>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>AASPS é uma Instituição Particular de Solidariedade Social registada com o n.º 07/89, a fls. 25 Verso e 26, do Livro n.º 1 das Instituições com Fins de Saúde</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;